<template>
  <div class="alert fade in m-b-15" v-bind:class="{ 'alert-danger': isError, 'alert-success': !isError }">
    {{ message }}
    <span class="close" data-dismiss="alert" v-on:click="$emit('closed')">×</span>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['isError', 'message']
}
</script>



// WEBPACK FOOTER //
// Alert.vue?972e527c